import template from './tagsBar.html';

const tagsBarComponent = {
  template,
  bindings: {
    tags: '<'
  }
};

export default function (ngModule) {
  ngModule.component('tagsBar', tagsBarComponent);
}
